import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppTableComponent, Form, FormElement, RequestsService, TranslationManager, ViewState, Auth, MessagesComponent, RequestOpnConsentModel, RequestOpnConsentListModel } from 'src/common';
import { DocumentViewModel } from 'src/views/components';

@Component({
	selector: 'opn-review',
	templateUrl: 'opn-review.component.html'
})

export class RequestOpnReviewComponent implements OnInit {

	@ViewChild(AppTableComponent) appTable: AppTableComponent;
	form: Form = new Form();

	auth = Auth;
	requestId: number;
	viewState = ViewState;
	showDisapprovalModal: boolean = false;
	translationManager = TranslationManager;

	items: RequestOpnConsentListModel[];
	userCanVote: boolean = true;
	userAlreadyVoted: boolean = false;
	opnDocument: DocumentViewModel;

	constructor(private requestsService: RequestsService, private route: ActivatedRoute) {
		this.requestId = this.route.snapshot.params.id;
	}

	ngOnInit(): void {
		Auth.checkAuthorization('F1440F1C-7E8C-43A8-A999-80C6543E9389');
		this.initForm();
		this.getOpnDocument();
	}

	private getOpnDocument() {
		this.requestsService.getOpnDocument(this.requestId).then((opnDocumentId: number) => {
			let model = new DocumentViewModel();
			model.documentId = opnDocumentId;
			this.opnDocument = model;
		})
	}

	private initForm(): void {
		this.form.elements["remark"] = new FormElement();

		this.requestsService.getOpnConsents(this.requestId).then(result => {
			if (result.findIndex((x: any) => x.userId == Auth.user.id) != -1) {
				this.userAlreadyVoted = true;
			}
		});

		this.requestsService.isBoardMember(this.requestId).then(result => {
			if (result) {
				this.requestsService.allTeamMembersGaveTheirOpnConsent(this.requestId).then(result => {
					this.userCanVote = result;
				});
			}
		});

	}

	setConsentStatus(isGivenConsent: boolean) {
		let model = new RequestOpnConsentModel();
		model.requestId = this.requestId;
		model.isGivenConsent = isGivenConsent;
		model.remark = isGivenConsent ? null : this.form.elements["remark"].value;

		this.requestsService.setOpnConsentStatus(model).then(() => {
			this.showDisapprovalModal = false;
			this.userAlreadyVoted = true;
			MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Подаци су успешно сачувани')]);
		}).catch((reason: any) => {
			MessagesComponent.instance.showError([reason.error.messages]);
		});
	}

	openDisapprovalModal() {
		this.showDisapprovalModal = true;
	}

	closeDisapprovalModal() {
		this.showDisapprovalModal = false;
	}
}
